export default "__VITE_ASSET__CuijR$gT__"